import Image from "components/Image"
import richText from "utilities/richText"

export default function ContentDog({ blok }) {
  return (
    <section className="px-8 bg-grayPawprint md:bg-[length:600px] xl:min-h-[334px]">
      <div className="md:flex max-w-screen-lg mx-auto">
        <div className="basis-2/3 prose-headings:text-white prose-h2:text-l1 prose-h2:lg:text-l2 prose-h2:leading-8 lg:prose-h2:leading-10 prose-h2:pb-2 prose-h3:text-s3 prose-h3:pb-2 prose-h3:uppercase prose-p:text-white py-12 md:pr-12 self-center">
          {richText(blok.content)}
        </div>
        <Image
          loader={undefined}
          src="/assets/pets/australian-shepherd-smiling.png"
          alt="austrailian shepherd smiling"
          width={362}
          height={262}
          className="object-contain w-full object-bottom basis-1/3 md:pt-4"
        />
      </div>
    </section>
  )
}
